import script from "./TncView.vue?vue&type=script&setup=true&lang=js"
export * from "./TncView.vue?vue&type=script&setup=true&lang=js"

import "./TncView.vue?vue&type=style&index=0&id=097c39a0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-097c39a0"]])

export default __exports__